<template lang="pug">
.count-down {{ countDownText }}
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    // 目标时间戳（毫秒）
    targetTime: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      day: '0',
      hour: '00',
      minute: '00',
      second: '00',
      timer: null,
    };
  },
  computed: {
    countDownText() {
      return `${this.day !== '0' ? `${this.day}天 ` : ''}${
        this.hour
      }:${this.minute}:${this.second} 后失效`;
    },
  },
  watch: {
    targetTime() {
      clearInterval(this.timer);
      this.startCountDown();
    },
  },
  mounted() {
    this.startCountDown();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    startCountDown() {
      this.updateTime();
      this.timer = setInterval(this.updateTime, 1000);
    },
    updateTime() {
      const now = Date.now();
      let diff = this.targetTime - now;
      if (diff <= 1000) {
        this.$emit('countDownEnd');
        this.day = '0';
        this.hour = '00';
        this.minute = '00';
        this.second = '00';
        clearInterval(this.timer);
        return;
      }
      const day = Math.floor(diff / (24 * 60 * 60 * 1000));
      diff %= 24 * 60 * 60 * 1000;
      const hour = Math.floor(diff / (60 * 60 * 1000));
      diff %= 60 * 60 * 1000;
      const minute = Math.floor(diff / (60 * 1000));
      diff %= 60 * 1000;
      const second = Math.floor(diff / 1000);

      this.day = String(day).padStart(1, '0');
      this.hour = String(hour).padStart(2, '0');
      this.minute = String(minute).padStart(2, '0');
      this.second = String(second).padStart(2, '0');
    },
  },
};
</script>
<style lang="less" scoped>
.count-down {
  white-space: nowrap;
  font-weight: 500;
  font-size: 0.11rem;
  line-height: normal;
  color: #fff;
}
</style>
